<template>
  <div class="membership-program main">
    <div class="wrapper">
      <!-- <button class="delete is-large" @click="close" /> -->
      <p class="subtitle" @click="close">
        <i class="fa fa-chevron-left" style="margin-right: 10px" />
        <span>Membership Program</span>
      </p>

      <MembershipProgramNewMember
        v-if="showNewMemberForm"
        :w="w"
        @close="showNewMemberForm = false"
        @new="updateMembers"
      />

      <div v-if="!showNewMemberForm">
        <div class="field is-grouped">
          <div v-if="showMembers" class="control">
            <a class="button is-grey" @click="showMembers = false">
              <i class="fa fa-chevron-left" />
            </a>
          </div>
          <div
            class="control search has-icons-right is-expanded"
            :class="{ 'has-icons-left': !showMembers }"
          >
            <span v-if="!showMembers" class="icon is-small is-left">
              <i class="fas fa-search" />
            </span>
            <span
              class="icon is-small is-right"
              style="pointer-events: initial"
              v-show="searchTerm"
              @click="clearSearch"
            >
              <i class="fa fa-times-circle" />
            </span>
            <input
              ref="input"
              class="input is-info"
              type="text"
              v-model="searchVal"
              :placeholder="searchPlaceholder"
              @keyup="search($event)"
              @focus="search($event)"
              @blur="clearSearch"
            />
          </div>
          <div v-if="!showMembers" class="control">
            <a class="button is-info" @click="newMember">
              <i class="fa fa-plus" /> &nbsp;New member
            </a>
          </div>
        </div>

        <MembershipList
          v-if="showMembers"
          :w="w"
          :members="members"
          :search="searchVal"
          @close="showMembers = false"
        />

        <div v-if="!showMembers">
          <div style="height: 12px" />
          <div class="notification" @click="showMembers = true">
            <i class="fa fa-users" />&nbsp;View all members
            <span v-if="members.length">({{ members.length }})</span>
            <i
              v-if="loading"
              class="fa fa-spinner fa-spin is-pulled-right has-text-info"
            />
          </div>
          <div class="notification" @click="manageMemberDeals">
            <i class="fa fa-tags" />&nbsp;Manage member deals
          </div>
        </div>

        <div
          v-if="searchResult.length > 0"
          class="list is-hoverable search-result"
        >
          <span
            v-for="s in searchResult"
            v-ripple
            class="list-item"
            :key="s.key + s.value"
            @click="chooseBusiness(s.value)"
            >{{ s.key }}</span
          >
        </div>
        <div v-show="showSearching" class="list search-result">
          <span class="list-item">
            <i class="fa fa-spinner fa-spin" />
          </span>
        </div>
        <div v-show="noResults && !showSearching" class="list search-result">
          <span class="list-item is-italic">
            <i>{{ $t("home2.no-results-for") }} "{{ searchTerm }}"</i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MembershipProgramNewMember from "@/components/MembershipProgramNewMember.vue";
import MembershipList from "@/components/MembershipList.vue";

export default {
  components: { MembershipProgramNewMember, MembershipList },
  props: {
    w: Object,
  },
  data() {
    return {
      members: [],
      loading: false,
      showMembers: false,
      showNewMemberForm: false,
      searchPlaceholder: "Search member",
      isSearching: false,
      searchResult: [],
      noResults: false,
      searchVal: null,
      searchTerm: null,
      lastSearch: null, // store last search when searchVal/searchTerm clear
      z: 0, // unnecessary...
    };
  },
  computed: {
    showSearching() {
      if (this.searchResult.length > 0) return false;
      return this.isSearching;
    },
  },
  mounted() {
    // this.$nextTick(() => this.$refs.input.focus());
    this.getMembers();
  },
  methods: {
    close() {
      this.$emit("close");
    },
    manageMemberDeals() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='margin-bottom:12px; font-size:1.2em'>
          <i class='fa fa-tags'></i>&nbsp;Manage Member Deals
        </p>
        <p>Just add tag 'Member' to a menu item to make it a member deal.</p>
        </div>`,
        showCloseButton: true,
      });
      this.goto("menu_editor");
    },
    getMembers() {
      // get all the members from DB
      var data = {
        workflowID: this.w.id,
        roleName: "Member",
      };
      this.loading = true;
      this.$store
        .dispatch("getRolesByWorkflowIDAndRoleName", data)
        .then((res) => {
          console.log("members", res.data);
          if (res.data) this.members = res.data;
        })
        .catch((err) => this.apiError(err))
        .finally(() => (this.loading = false));
    },
    updateMembers() {
      this.showNewMemberForm = false;
      this.getMembers();
    },
    newMember() {
      this.showNewMemberForm = true;
      //   this.$swal({
      //     title: `Create new member`,
      //     html: `<div style='text-align:left'>
      //     <p>Enter the new member's mobile number.</p>
      //     <p style='margin-top:12px'>This should be the same number they use to log in to TUK App.</p>
      //     </div>`,
      //     input: "text",
      //     showCloseButton: true,
      //     showCancelButton: false,
      //     confirmButtonText: "Create",
      //     inputValidator: (val) => {
      //       if (!val) return `A mobile phone number is required`;
      //     },
      //   }).then((val) => {
      //     if (val.value) {
      //       //   var data = { unit_number: val.value };
      //       //   this.createMemberRole(w, data);
      //       return;
      //     }
      //   });
    },
    chooseBusiness(businessID) {
      console.log("chooseBusiness", businessID);
      this.getSuperRole(businessID);
    },
    updateSuperRole(businessID) {
      var payload = {
        workflow_type: "Commerce",
        business_id: businessID,
      };
      this.$store
        .dispatch("getBusinessAndWorkflow", payload)
        .then((res) => this.$store.commit("updateSuperRole", res.data))
        .catch((err) => this.apiError(err));
    },
    getSuperRole(businessID) {
      var payload = {
        workflow_type: "Commerce",
        business_id: businessID,
      };
      this.$store
        .dispatch("getBusinessAndWorkflow", payload)
        .then((res) => {
          console.log("businessAndWorkflow", res.data);
          this.createSuperuserRole(res.data);
        })
        .catch((err) => this.apiError(err));
    },
    createSuperuserRole(data) {
      // this.superRoles.forEach((r) => (r.active = false));
      // no need to check if these exist, will return error if not exist
      var business = data.business;
      var workflow = data.workflows[0]; // could be more than 1?
      var role = {
        business_id: business.id,
        workflow_id: workflow.id,
        role_type: "worker",
        role_name: "Commerce Agent",
        business: business,
        workflow: workflow,
        active: false, // flag to indicate if it's being used now
      };
      this.$store.commit("addSuperRole", role);
      setTimeout(() => {
        var r = this.superRoles.find((r) => r.business_id === role.business_id);
        this.toggleActive(r);
      }, 300);
    },
    clearRoles() {
      this.$store.commit("addSuperRole", null);
      this.successToast("Cleared superRoles!");
    },
    toggleActive(role) {
      if (role.active) {
        role.active = false;
        this.warningToast("Deactivated!");
      } else {
        this.superRoles.forEach((r) => (r.active = false));
        role.active = true;
        this.infoToast("Activated!", "top");
        setTimeout(() => this.close(), 700);
        this.updateSuperRole(role.business_id);
      }
      this.$emit("changed"); // on activate get all the latest role / business / workflow etc data needed
    },
    clearSearch() {
      this.searchVal = null;
      this.searchTerm = null;
      this.noResults = false;
      setTimeout(() => (this.searchResult = []), 300);
    },
    search(e) {
      this.showMembers = true;
      var text = e.target.value; //   var text = this.searchVal;
      this.searchTerm = text; // a hack for mobile...
      this.lastSearch = text;
      console.log("search", text);
      if (text.length < 3) {
        // this.searchResult = [];
        console.log("frequentShops", this.$store.getters.getFrequentShops);
        this.searchResult = this.$store.getters.getFrequentShops.filter((s) =>
          s.key.toLowerCase().includes(text.toLowerCase())
        );
        this.isSearching = false;
        this.noResults = false;
        return;
      }
      this.isSearching = true;
      this.$store
        .dispatch("autocompleteSearch", text)
        .then((res) => {
          if (res.data) {
            if (res.data.businesses) {
              this.searchResult = res.data.businesses;
              this.noResults = false;
            } else {
              this.searchResult = [];
              this.noResults = true;
            }
          } else {
            this.searchResult = [];
            this.noResults = true;
          }
        })
        .catch((err) => console.error("searchAutocomplete", err))
        .finally(() => (this.isSearching = false));
    },
  },
};
</script>

<style scoped>
.main {
  position: absolute;
  top: 0;
  width: 100vw;
  max-width: 600px;
  height: 100vh;
  background-color: rgba(255, 255, 255, 1);
  z-index: 21;
  backdrop-filter: blur(3px);
}
.wrapper {
  padding: 16px;
}
.subtitle {
  text-align: left;
  font-weight: 500;
  margin-bottom: 16px;
}
.delete {
  position: absolute;
  right: 12px;
  top: 12px;
}
.notification {
  padding: 20px;
}
.super-role {
  background-color: rgb(199, 192, 192);
}
.active {
  background-color: rgb(227, 255, 227);
}
.search-result {
  text-align: left;
}
</style>